import {
  crearProducto,
  actualizarProducto,
  eliminarProducto,
  listarProducto,
} from "../services/gproductos";

const state = {
  data: { data: [], total: 0 },
};

const getters = {
  getLista: (state) => state.data.data,
  getTotal: (state) => state.data.total,
};

const mutations = {
  setData: (state, data) => (state.data = data),
  setCreated: ({ data }, producto) => data.data.push(producto),
  setUpdated: ({ data }, producto) => {
    const index = data.data.findIndex((e) => e.Id == producto.Id);
    data.data[index] = producto;
  },
  setDeleted: ({ data }, idProducto) => {
    const index = data.data.findIndex((e) => e.Id == idProducto);
    data.data.splice(index, 1);
  },
};

const actions = {
  async listar({ commit, rootState }, params = {}) {
    if (!params?.rows) params.rows = rootState.porPagina;
    commit("setIsLoading", true, { root: true });
    const { data, status } = await listarProducto(params);
    commit("setIsLoading", false, { root: true });
    status == 200 ? commit("setData", data) : this.$alertStatus(status, data);
  },
  async crear({ commit }, datos) {
    commit("setIsLoading", true, { root: true });
    const { data, status } = await crearProducto(datos);
    commit("setIsLoading", false, {
      root: true,
    });
    status == 201
      ? commit("setCreated", data)
      : this.$alertStatus(status, data);

    return status;
  },
  async actualizar({ commit }, datos) {
    commit("setIsLoading", true, { root: true });
    const { data, status } = await actualizarProducto(datos);
    commit("setIsLoading", false, {
      root: true,
    });
    status == 200
      ? commit("setUpdated", data)
      : this.$alertStatus(status, data);

    return status;
  },
  async eliminar({ commit }, idProducto) {
    commit("setIsLoading", true, { root: true });
    const { data, status } = await eliminarProducto(idProducto);
    commit("setIsLoading", false, {
      root: true,
    });
    status == 204
      ? commit("setDeleted", idProducto)
      : this.$alertStatus(status, data);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};
